// throw an error that would be picked up globally as an unhandled error,
// without having to emit an error on the observable (which would close the stream).
// There could be unintended issues with doing it this way, but it seems fine for now i guess.
// This is basically like hostReportError in rxjs
export function throwAsyncError(error: unknown): void {
  setTimeout(() => {
    throw error;
  });
}

// usable at the end of an expression:
// return somecall() || throwSyncError();
export function throwSyncError(error: unknown): never {
  throw error;
}
